export default __webpack_public_path__ + "static/media/reloj-blanco.d7513e70.svg";